// extracted by mini-css-extract-plugin
module.exports =  {"more-button":"_33974c2b58--more-button--plYc5"};